import getMaxDomainDiscount from './get-max-domain-discount';

export default {
  getMaxDomainDiscount,
};
